import { useQuery } from '@tanstack/react-query';
import http from 'helpers/requests';
import { notifyError } from 'modules/Common/ui/toast';

export const getInstallationDiagramsQueryOptions = (installationId) => ({
  queryKey: ['installationDiagrams', installationId],
  queryFn: async () => {
    const response = await http.get(`/diagrams/installation/${installationId}`);
    return response.data;
  },
  enabled: !!installationId,
  onError: notifyError,
});

export const useFetchInstallationDiagrams = (installationId) =>
  useQuery(getInstallationDiagramsQueryOptions(installationId));
